import { produce } from 'immer'
import { actionTypesFor } from '../common/redux-crud-actions'

import { FETCH_STATE_PENDING, FETCH_STATE_FULFILLED, FETCH_STATE_REJECTED } from '../common/constants'

/**
 * To avoid unnecessary data fetching and because data fetching is triggered on mounting of the appropriate
 * view components, we store  the info, if the appropriate REST resource has already been fetched in the redux store.
 * This is the appropriate reducer for it.
 * If a fetchStart... action is dispatched for a REST resource, the resource is marked as fetched in the store.
 */
export default produce((draft, action) => {
    const { requestKey, resourceName, type } = action
    if (resourceName) {
        const actionTypes = actionTypesFor(resourceName)
        if (!draft[resourceName]) {
            draft[resourceName] = {}
        }
        switch (type) {
            case actionTypes.fetchStart: {
                draft[resourceName][requestKey] = FETCH_STATE_PENDING
                break
            }
            case actionTypes.fetchSuccess: {
                draft[resourceName][requestKey] = FETCH_STATE_FULFILLED
                break
            }
            case actionTypes.fetchError: {
                draft[resourceName][requestKey] = FETCH_STATE_REJECTED
                break
            }
        }
    }
}, {})
